import { Injectable } from '@angular/core';
import { InjectableMapDataStateService } from '@ui/shared/domain-map';
import type { EconomicDevelopmentMapItem } from '../definitions/economic-development-map-item';
import type { EconomicDevelopmentFilterKey } from '../types/economic-development-filter';

@Injectable({ providedIn: 'root' })
export class EconomicDevelopmentMapMapDataService
    extends InjectableMapDataStateService<EconomicDevelopmentMapItem, EconomicDevelopmentFilterKey> {
}
